<script lang="ts" module>
  import type { Snippet } from 'svelte';
  import type { SystemStyleObject } from '@agapi/ui/panda/types';

  export interface SelectContentProps {
    children?: Snippet,
    positionerStyles?: SystemStyleObject
    contentStyles?: SystemStyleObject
  }
</script>

<script lang="ts">
  import { portal } from '@zag-js/svelte';
  import { css } from '@agapi/ui/panda/css';

  import { useSelectContext } from '../use-select-context';
  import { selectStyles } from '../select.styles';

  const classes = selectStyles.raw();

  const { children, positionerStyles, contentStyles }: SelectContentProps = $props();
  const select = useSelectContext();
</script>

<div use:portal {...select.api.getPositionerProps()} class={css(positionerStyles)}>
  <ul {...select.api.getContentProps()} class={css(classes.content, contentStyles)}>
    {#if children}
      {@render children()}
    {/if}
  </ul>
</div>
